const OPTIMISTIC_ID_PREFIX = "optimistic-";

export const generateMessageId = () =>
  `msg-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

export const generateOptimisticId = () =>
  `${OPTIMISTIC_ID_PREFIX}${generateMessageId()}`;

export const isOptimisticId = (id: string) =>
  id.startsWith(OPTIMISTIC_ID_PREFIX);
